import { render } from "./CatalogQr.vue?vue&type=template&id=34c1a49b&scoped=true"
import script from "./CatalogQr.vue?vue&type=script&lang=js"
export * from "./CatalogQr.vue?vue&type=script&lang=js"

import "./CatalogQr.vue?vue&type=style&index=0&id=34c1a49b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c1a49b"]])

export default __exports__